import { AccountCircle, Home, Logout } from "@mui/icons-material";
import { Button, IconButton, Tooltip } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Url } from "../../constants";

const TopBar = () => {
    const Navigate = useNavigate()
    const token = localStorage.getItem("token")
    const user_datos = JSON.parse(localStorage.getItem("user"))
    
    const [optionMenu, setoptionMenu] = useState("Archivos")
    const [pantallas_disp, setpantallas_disp] = useState([])

    const getPantallasbyRol = async () => {
        await axios.get(Url + "GetRol?id=" + user_datos.roluser_id, {
            headers: {
                Authorization: token
            }
        })
        .then(res => {
            const copypant_disp = [...pantallas_disp]

            res.data.forEach(element => {
                copypant_disp.push(element.pantalla.pantalla)
            });
            setpantallas_disp(copypant_disp)
        })
        .catch(err => {
            console.log(err)
        })
    }

    useEffect(() => {
        const optionSaved = localStorage.getItem("option")
        if (optionSaved) {
            setoptionMenu(optionSaved)
        }

        getPantallasbyRol()
    },[])

    const handleChangeView = async (pantalla) => {
        setoptionMenu(pantalla)
        localStorage.setItem("option", pantalla)
        
        switch (pantalla) {
            case "Archivos":
                Navigate('/archivos');
                break;

            case "Histórico Descargas":
                Navigate('/historial');
                break;

            case "Usuarios":
                Navigate('/usuarios');
                break;

            default:
                break;
        }
    }

    const styleWhite = {
        color: "white"
    }

    return (
        <div style={{width:"100%", backgroundColor:"black", display:"flex", 
        justifyContent:"space-between", padding:"5px 15px 5px 15px", alignItems:"center"}}>
            <img src="https://trafficlight.mx/wp-content/uploads/2022/04/logo-footer-160.svg" alt="LogoTL"
            height={45}/>

            <div style={{display:"flex", gap:5, alignItems:"center"}}>
                {pantallas_disp.includes("Archivos") &&
                    <Button sx={{...styleWhite, fontSize:"13px", 
                    textDecoration: optionMenu === "Archivos" ? "underline" : "none",
                    ":hover":{textDecoration:"underline"}}}
                    onClick={() => handleChangeView("Archivos")}
                    >Archivos</Button>
                }

                {pantallas_disp.includes("Histórico Descargas") &&
                    <Button sx={{...styleWhite, fontSize:"13px",
                    textDecoration: optionMenu === "Histórico Descargas" ? "underline" : "none",
                    ":hover":{textDecoration:"underline"}}}
                    onClick={() => handleChangeView("Histórico Descargas")}
                    >Histórico <br /> Descargas</Button>
                }

                {pantallas_disp.includes("Usuarios") &&
                    <Button sx={{...styleWhite, fontSize:"13px",
                    textDecoration: optionMenu === "Usuarios" ? "underline" : "none",
                    ":hover":{textDecoration:"underline"}}}
                    onClick={() => handleChangeView("Usuarios")}
                    >Usuarios</Button>
                }
            </div>

            <div style={{display:"flex", gap:10, alignItems:"center"}}>
                <Tooltip title="Módulos" arrow>
                    <IconButton sx={styleWhite} size="small" 
                    onClick={() => {
                        Navigate("/main")
                    }}>
                        <Home />
                    </IconButton>
                </Tooltip>

                <AccountCircle sx={styleWhite}/>
                <label style={styleWhite}>{user_datos.user_name}
                    {user_datos.roluser_id !== 5 ? "- " + user_datos.roluser_name : ""}
                </label>
                <Tooltip title="Salir" arrow>
                    <IconButton sx={styleWhite} size="small" 
                    onClick={() => {
                        Navigate("/login")
                        localStorage.clear()
                    }}>
                        <Logout />
                    </IconButton>
                </Tooltip>
            </div>
        </div>
    );
}
export default TopBar;